import './style.scss';
import {initArchiveFilterSearch} from "../../scripts/archive-filter-search";

export function gear_type_collection() {
// Filter and Search Handler for archive
    initArchiveFilterSearch({
        root: '.gear_type_collection',
        counterInputsSelector: [
            'input[type="checkbox"][name="product-type[]"]',
            'input[type="checkbox"][name="make[]"]',
            'input[type="checkbox"][name="weight-class[]"]',
        ].join(', '),
    });

}
